import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const CompanyBilling = ShModel.extend({
  advanceFee: attr('number'),
  autocharge: attr('boolean'),
  billableName: attr('string'),
  billableText: attr('string'),
  cancelFee: attr('number'),
  delinquentFee: attr('number'),
  expenseFee: attr('number'),
  finderFee: attr('number'),
  inviteeFee: attr('number'),
  invoiceNet: attr('number'),
  isBillable: attr('boolean'),
  lastStripeSync: attr('date'),
  onInvoice: attr('boolean'),
  paymentInstructionsText: attr('string'),
  selectBaseFee: attr('number'),
  selectFee: attr('number'),
  stripeId: attr('string'),

  //Relationships
  company: belongsTo('company', { async: false }),
});

export default CompanyBilling;
